import { Button as FlowbiteButton, Spinner } from 'flowbite-react';
import type { FunctionComponent } from 'react';

import type { ButtonProps } from './types';

//TODO Add variants as needed
const buttonVariants = {
	primary: 'bg-brand border-2 border-brand !text-white hover:opacity-70 active:opacity-80 disabled:opacity-50',
	secondary: 'bg-dark border-2 border-dark text-white hover:opacity-70 active:opacity-80 disabled:opacity-50',
	tertiary: 'bg-transparent text-dark border-0',
	'ghost-secondary':
		'bg-transparent text-dark border-2 border-n400_input_stroker hover:bg-n400_input_stroker hover:border-n500_light_text disabled:opacity-50 disabled:border-n400_input_stroker disabled:bg-transparent dark:text-n700_text_dark_mode dark:hover:bg-n600_text',
	'ghost-primary': 'bg-transparent text-brand border-2 border-brand',
	text: 'bg-transparent border-none hover:opacity-70 active:opacity-80 disabled:opacity-50 dark:active:opacity-90 dark:hover:opacity-100 dark:disabled:opacity-70',
};

const buttonSizes = {
	large: 'text-lg',
	medium: 'text-base',
	small: 'text-sm',
};

const iconVariants = {
	large: 'text-2xl h-6 w-6',
	medium: 'text-xl h-5 w-5',
	small: 'text-base h-4 w-4',
};

const iconPositions = {
	left: 'ml-0 mr-2',
	right: 'mr-0 ml-2',
};

const customTheme = {
	base: '',
	size: {},
	disabled: 'cursor-not-allowed',
};

export const Button: FunctionComponent<ButtonProps> = ({
	icon,
	children,
	className,
	isLoading,
	sizing = 'medium',
	iconPosition = 'left',
	variant = 'primary',
	...props
}) => {
	const renderIcon = () => {
		if (!icon) return null;
		return <div className={`${iconVariants[sizing]} ${iconPositions[iconPosition]}`}>{icon}</div>;
	};

	const buttonClasses = `w-full flex justify-center items-center font-medium !rounded-button outline-none px-2 py-[5px] transition duration-300 ease-in-out focus:ring-0 focus:ring-transparent disabled:cursor-not-allowed ${buttonVariants[variant]} ${buttonSizes[sizing]} ${className}`;

	return (
		<FlowbiteButton {...props} theme={customTheme} size={sizing} className={buttonClasses}>
			{icon ? (
				<div className='flex items-start justify-center'>
					{iconPosition === 'left' && renderIcon()}
					<div>{children}</div>
					{iconPosition === 'right' && renderIcon()}
				</div>
			) : (
				<div className='flex justify-center items-center'>
					{isLoading && <Spinner size={'sm'} theme={{ base: 'inline animate-spin text-n50_hover' }} className={'fill-accent mr-1'} />}
					{children}
				</div>
			)}
		</FlowbiteButton>
	);
};
